module.exports = __webpack_public_path__ + "img/L2B.1d02aa22.jpg";